// extracted by mini-css-extract-plugin
module.exports = {"footer":"_103a151b99--footer--ewDNQ"};